import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

import Marcas1 from "../../static/media/home/marcas1.webp";
import Marcas2 from "../../static/media/home/marcas2.webp";
import Marcas3 from "../../static/media/home/marcas3.webp";
import Marcas4 from "../../static/media/home/marcas4.webp";
import Marcas5 from "../../static/media/home/marcas5.webp";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  navyDark: "#003D73",
  gold: "#FFCD00",
  goldDark: "#E6B800",
  teal: "#5BC8AF",
  gray: "#F5F7FA",
  white: "#ffffff",
};

const ROW_1 = [Marcas1, Marcas3, Marcas5];
const ROW_2 = [Marcas2, Marcas4];

function MarqueeRow({ images, duration, reverse = false }) {
  const track = [...images, ...images];
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        maskImage:
          "linear-gradient(90deg, transparent 0%, #000 8%, #000 92%, transparent 100%)",
        WebkitMaskImage:
          "linear-gradient(90deg, transparent 0%, #000 8%, #000 92%, transparent 100%)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "max-content",
          gap: { xs: "16px", md: "24px" },
          animation: `${reverse ? "marquee-reverse" : "marquee"} ${duration}s linear infinite`,
          "&:hover": { animationPlayState: "paused" },
          "@keyframes marquee": {
            "0%": { transform: "translateX(0)" },
            "100%": { transform: "translateX(-50%)" },
          },
          "@keyframes marquee-reverse": {
            "0%": { transform: "translateX(-50%)" },
            "100%": { transform: "translateX(0)" },
          },
        }}
      >
        {track.map((src, i) => (
          <Box
            key={i}
            sx={{
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              background: C.white,
              borderRadius: "14px",
              px: { xs: "20px", md: "32px" },
              py: { xs: "14px", md: "18px" },
              boxShadow: "0 4px 16px rgba(12,31,47,0.07)",
              border: "1px solid rgba(12,31,47,0.06)",
              transition: "box-shadow .2s",
              "&:hover": { boxShadow: "0 8px 24px rgba(12,31,47,0.12)" },
            }}
          >
            <Box
              component="img"
              src={src}
              alt="Marcas aliadas ElectricaGRM"
              sx={{
                height: { xs: "28px", md: "38px" },
                width: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default function Aliados() {
  return (
    <Box
      id="aliados"
      sx={{
        background: C.white,
        pt: { xs: "64px", md: "88px" },
        pb: 0,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          width: "100%",
          px: { xs: "20px", sm: "32px", md: "40px" },
          boxSizing: "border-box",
        }}
      >
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          sx={{ textAlign: "center", mb: { xs: 5, md: 8 } }}
        >
          <Typography
            variant="h2"
            sx={{
              color: C.dark,
              fontWeight: 900,
              fontSize: { xs: 26, sm: 32, md: 40 },
              letterSpacing: "-.02em",
              lineHeight: 1.1,
              mb: 1.5,
            }}
          >
            Nuestros Aliados
          </Typography>
          <Typography
            sx={{
              color: "#5c6c7a",
              fontSize: { xs: 13.5, md: 15.5 },
              maxWidth: 520,
              mx: "auto",
              lineHeight: 1.65,
            }}
          >
            Distribuimos marcas líderes a nivel mundial en material eléctrico,
            herramientas e iluminación, con garantía y soporte directo de
            fábrica.
          </Typography>
        </Box>

        <Box
          component={motion.div}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "16px", md: "20px" },
          }}
        >
          <MarqueeRow images={ROW_1} duration={28} />
          <MarqueeRow images={ROW_2} duration={24} reverse />
        </Box>
      </Box>

      {/* Transición extendida hacia azul */}
      <Box
        sx={{
          height: { xs: "120px", md: "100px" },
          background: `linear-gradient(180deg, ${C.white} 0%, ${C.navy} 100%)`,
          mt: { xs: 7, md: 10 },
        }}
      />
    </Box>
  );
}
